module.exports = __webpack_public_path__ + "h5/img/down.1c9c48a0.png";